import { useCallback, useMemo } from "react"
import PropTypes from "prop-types"
import { Autocomplete, TextField, Tooltip } from "@mui/material"
import { chain, map } from "lodash"

export default function CompareSelect({ options, selectedOption, setSelected, saveToStore, storeName, slotProps, classes }) {
  const handleSetSelected = useCallback((_, option) => {
    setSelected(option.id)
    if (saveToStore) {
      saveToStore(option.id, storeName)
    }
  }, [setSelected, saveToStore, storeName])

  const formattedOptions = useMemo(() => chain(options)
    .map(category => map(category.options, option => ({
      ...option,
      category: category.label,
    })))
    .flatten()
    .value(),
  [options])

  const content = <Autocomplete
    data-test-class="select-compare-metric"
    fullWidth
    options={formattedOptions}
    value={selectedOption}
    blurOnSelect
    clearOnBlur
    disableClearable
    groupBy={option => option.category}
    isOptionEqualToValue={(option, value) => option.id === value.id}
    onChange={handleSetSelected}
    renderInput={(params) => <TextField
      {...params}
      variant="standard"
    />}
    classes={classes}
    slotProps={slotProps}
  />

  return selectedOption?.label ? <Tooltip title={selectedOption.label}>{content}</Tooltip> : content
}

CompareSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })).isRequired,
  })).isRequired,
  selectedOption: PropTypes.shape({
    label: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
  }).isRequired,
  setSelected: PropTypes.func.isRequired,
  saveToStore: PropTypes.func,
  storeName: PropTypes.string,
  slotProps: PropTypes.object,
  classes: PropTypes.object,
}
